import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import type {RootState} from "../../stores";
import Category from "./category.tsx";
import {closeModalBottom} from "../../stores/modal.bottom.slice.ts";


const ModalBottom: React.FC = () => {
  const dispatch = useDispatch();
  let { isOpen, type, data } = useSelector((state: RootState) => state.modalBottom);

  const handleClose = () => {
    dispatch(closeModalBottom());
  };

  const getComponent = () => {
    switch (type) {
      case 'category':
        return <Category current={data} callback={handleClose} />;
      default:
        isOpen = false;
        break;
    }
    return
  };

  if (!isOpen) return null;

  return (
    <div id="myModal" className="modal" onClick={handleClose} style={{display: "block"}}>
      <div className="modal-content">
        <div className="modal-body">
          {getComponent()}
        </div>
      </div>
    </div>
  );
};

export default ModalBottom;